import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { SingleImgContainer } from "../../styles/Components/SingleImg"
import Img from "../../utils/OptimizedImage"

const SingleImg = ({ component, grid }) => {
  const bgClass = component?.background?.replace(/ /g, "").toLowerCase()
  return (
    <SingleImgContainer
      className={`bg-${bgClass} container-${
        grid !== "" ? grid?.toLowerCase() : "normal"
      }`}
    >
      <Container>
        <Row>
          <Col>
            <div className="main-container">
              <Img
                src={component?.desktop?.url}
                msrc={component?.mobile?.url}
                alt={component?.desktop?.title}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </SingleImgContainer>
  )
}

export default SingleImg
